import { InvoiceSendOptions } from '../../../domain/invoicing/invoicingApi'

// "Require payment method on file" only makes sense while "Show" is enabled.
// Turning show off therefore also clears require.
export const toggleShowAuthorizePaymentOnFile = (options: InvoiceSendOptions): InvoiceSendOptions => ({
  ...options,
  showAuthorizePaymentOnFile: !options.showAuthorizePaymentOnFile,
  requireAuthorizePaymentOnFile: options.showAuthorizePaymentOnFile
    ? false
    : options.requireAuthorizePaymentOnFile,
})

export const toggleRequireAuthorizePaymentOnFile = (options: InvoiceSendOptions): InvoiceSendOptions => ({
  ...options,
  requireAuthorizePaymentOnFile: !options.requireAuthorizePaymentOnFile,
})
